var exports = {
  "kL": "xdbfd91f1--c8ae9b--container",
  "W2": "xdbfd91f1--c8ae9b--scroll",
  "UE": "xdbfd91f1--c8ae9b--arrow",
};

module.exports = exports;
